export enum EPropertyMangerUrl {
  PROPERTY_MANAGER = 'property_manager/api/v2',
}
